<template>
  <a-popover
    trigger="click"
    overlay-class-name="key-result-alignment"
  >
    <template #content>
      <AlignInvitation
        v-bind="$attrs"
      />
    </template>
    <a-space
      class="clickable"
      @click.stop
    >
      <IconFont
        type="iconduiqi"
        class="icon-block"
      />
      {{ $t('okr.list.inviteToAlign') }}
    </a-space>
  </a-popover>
</template>

<script>
import AlignInvitation from './AlignInvitation'

export default {
  name: 'AlignInvitationDialog',
  components: {
    AlignInvitation
  },
  inheritAttrs: false
}
</script>
